import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Page,
  ResourceList,
  Text,
} from '../../components';
import api from '../../utils/services';
import clientUrl from './clients/clientUrl';

const propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      clients: null,
    };
  }

  componentDidMount() {
    api.getClients()
      .then((data) => {
        this.setState({ clients: data.sort((x, y) => x.name.localeCompare(y.name)) });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { match } = this.props;
    const { loading, clients } = this.state;

    return (
      <Page
        title="Clients"
        subtitle={clients && `Total clients: ${clients.length}`}
        primaryAction={{ content: 'Add client', href: `${match.url}/new` }}
      >
        <Card loading={loading}>
          <ResourceList
            items={clients || []}
            renderItem={(client) => {
              const shortcutActions = (
                <Button as="a" href={clientUrl(client.subdomain)}>Switch To Client</Button>
              );
              return (
                <ResourceList.Item
                  key={client.id}
                  url={`${match.url}/${client.id}`}
                  shortcutActions={shortcutActions}
                  id={client.id}
                >
                  <Text as="h3" noMargins>{client.name}</Text>
                </ResourceList.Item>
              );
            }}
          />
        </Card>
      </Page>
    );
  }
}

Clients.propTypes = propTypes;
